import lazyScreen from '../utils/lazyScreen';
const AREvent = lazyScreen(() => import('../pages/event/AREvent/index.js'), 'pages/event/AREvent/index.js');
const AREvents = lazyScreen(() => import('../pages/event/AREvents/index.js'), 'pages/event/AREvents/index.js');
const AREventSessions = lazyScreen(() => import('../pages/event/AREventSessions/index.js'), 'pages/event/AREventSessions/index.js');
const AREventSessionStatuses = lazyScreen(() => import('../pages/event/AREventSessionStatuses/index.js'), 'pages/event/AREventSessionStatuses/index.js');
const AREventTicket = lazyScreen(() => import('../pages/event/AREventTicket/index.js'), 'pages/event/AREventTicket/index.js');
const AREventTickets = lazyScreen(() => import('../pages/event/AREventTickets/index.js'), 'pages/event/AREventTickets/index.js');

export default [
    {
        path: '/event/AREvents',
        component: AREvents
    },
    {
        path: '/event/AREvent/:code',
        component: AREvent
    },
    {
        path: '/event/AREventSessions',
        component: AREventSessions
    },
    {
        path: '/event/AREventSessionStatuses',
        component: AREventSessionStatuses
    },
    {
        path: '/event/AREventTickets',
        component: AREventTickets
    },
    {
        path: '/event/AREventTicket/:code',
        component: AREventTicket
    }
];
